<template>
    <a href="#" @click.stop.prevent="click">
        <slot></slot>
    </a>
</template>

<script>
    export default {
        methods: {
            click () {
                this.$router.back();
            }
        }
    }
</script>